import {Injectable} from '@angular/core';
import {map, Observable} from "rxjs";
import {CurrencyExchangeRateQuery, StripeChargeLimitsQuery, StripeChargeLimitsResult} from "@generated/graphql";
import { StripeChargeLimits } from '@shared/helpers/stripe-charge-limit.helper';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  constructor(
    private readonly currencyExchangRateQuery: CurrencyExchangeRateQuery,
    private readonly stripeChargeLimitsQuery: StripeChargeLimitsQuery,
  ) {
  }

  getCurrencyExchangeRate(fromCurrency: string, toCurrency: string = 'USD'): Observable<number> {
    return this.currencyExchangRateQuery.fetch({fromCurrency, toCurrency}, {fetchPolicy: 'no-cache'}).pipe(
      map(res => res.data.currencyExchangeRate)
    )
  }

  getStripeChargeLimits(currency: string): Observable<StripeChargeLimits | null> {
    return this.stripeChargeLimitsQuery.fetch(
      {
        currency,
        paymentMethodType: 'card',
      },
      {fetchPolicy: 'no-cache'},
    ).pipe(
      map((res) => this.mapStripeChargeLimits(res.data.stripeChargeLimits)),
    );
  }

  private mapStripeChargeLimits(limits: StripeChargeLimitsResult['stripeChargeLimits']): StripeChargeLimits | null {
    if (!limits) {
      return null;
    }

    return {
      currency: limits.currency,
      minimumAmountMinor: limits.minimumAmountMinor ?? null,
      maximumAmountMinor: limits.maximumAmountMinor,
      chargePrecision: limits.chargePrecision,
      requiresWholeUnitCharge: limits.requiresWholeUnitCharge,
    };
  }
}
